/**
 * @generated SignedSource<<8083dfbcb9ba5ae52cf5f7329968cf3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeBlocksFieldSections_blocksConnection$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string;
    };
  }>;
  readonly " $fragmentType": "WhatToSeeBlocksFieldSections_blocksConnection";
};
export type WhatToSeeBlocksFieldSections_blocksConnection$key = {
  readonly " $data"?: WhatToSeeBlocksFieldSections_blocksConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksFieldSections_blocksConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeBlocksFieldSections_blocksConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WhatToSeeBlockEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WhatToSeeBlock",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "WhatToSeeBlockConnection",
  "abstractKey": null
};

(node as any).hash = "1ece21dc6343fb17b67d8ceedc73ec6f";

export default node;
